import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';

import UserList from '../../pages/wishItem/UserList';

const CustomTabPanel = (props) => {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ pt: 2 }}>{children}</Box>}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

const TabIndex = ({
  dateRange,
  searchKeyword,
  userList,
  setUserList,
  sortUserList,
  setSortUserList,
  getUserList,
  isLoading,
  setIsLoading
}) => {
  const [value, setValue] = useState(1);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  }

  return (
    <Box sx={{ width: '100%' }}>
      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs value={value} onChange={handleChange}>
          <Tab label="熱門清單商品" disabled />
          <Tab label="所有用戶清單" />
        </Tabs>
      </Box>
      <CustomTabPanel value={value} index={0}>
        無資料...
      </CustomTabPanel>
      <CustomTabPanel value={value} index={1}>
        <UserList
          searchKeyword={searchKeyword}
          userList={userList}
          sortUserList={sortUserList}
          setSortUserList={setSortUserList}
          getUserList={getUserList}
          isLoading={isLoading}
          setIsLoading={setIsLoading}
        />
      </CustomTabPanel>
    </Box>
  );
}

export default TabIndex;
